<template>
  <div
    class="card card-body"
    :class="bgClass"
    v-if="partners.length > 0"
  >
    <p class="text-muted">
      <strong>{{ $t('sentence.collaboration_with') }}</strong>
    </p>
    <v-carousel
      :perPage="perPage"
      :autoplay="true"
      :autoplayTimeout="5000"
      :paginationEnabled="false"
      :loop="true"
      :speed="2000"
    >
      <v-slide
        v-for="partner in partners"
        :key="partner.id"
      >
        <div class="h-100 d-flex justify-content-center align-items-center">
          <img
            :src="partner.logo"
            class="img-thumbnail w-75"
            alt="partner"
          >
        </div>
      </v-slide>
    </v-carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import { fetchPartners } from '@/public/api';

export default {
  name: 'PartnersCarousel',
  props: {
    bgClass: {
      default() {
        return 'bg-white';
      },
    },
    perPage: {
      type: Number,
      default() {
        return 8;
      },
    },
  },
  components: {
    'v-carousel': Carousel,
    'v-slide': Slide,
  },
  data() {
    return {
      partners: [],
    };
  },
  methods: {
    async fetchPartners() {
      const response = await fetchPartners();
      this.partners = response.data;
    },
  },
  created() {
    this.fetchPartners();
  },
};
</script>
